module.exports = __webpack_public_path__ + "static/media/DSC09397-2.5f7b7216.jpeg";